// extracted by mini-css-extract-plugin
export default {"survey_1":"index-module_survey_1_CFG1r","surveyList":"index-module_surveyList_6hpaI","surveyItem":"index-module_surveyItem_I-3eh","imagePart":"index-module_imagePart_2a-8l"};